export function generateUrlParamsFromArray(arr: any[], key: string, skipValue?: any[]) {
    let paramsString = "";

    arr?.forEach((value, index) => {
        if (!skipValue?.includes(value)) paramsString += `${index ? "&" : ""}${key}=${value}`;
    });
    return paramsString;
}
